import { useNavigate } from "react-router";
import Button from "src/components/elements/Button/Button";
import styles from "src/features/Event/components/RecommendedArtistDialog/recommendedArtistDialog.module.css";
import getCurrentUserId from "src/utils/currentUserId";
import getUserIconUrl from "src/utils/getUserIconUrl";
import imageLoadErrorHandler from "src/utils/imageLoadErrorHandler";
import swrFetcher from "src/utils/swrFetcher";
import useSWR from "swr";
import { S3_URL } from "src/config";
import { useSetAtom } from "jotai";
import { useState } from "react";
import type { RandomCertifiedArtistVideo } from "../../event.type";
import { alreadyShowedRecommendedArtistDialogAtom } from "../../event.atom";

const RecommendedArtistDialog: React.FC = () => {
    const currentUserId = getCurrentUserId();
    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(true);

    const setAlreadyShowedRecommendedArtistDialog = useSetAtom(
        alreadyShowedRecommendedArtistDialogAtom
    );

    const navigateArtistProfile = (artistId: number) => {
        if (artistId === Number(currentUserId)) {
            navigate("/profile");
            return;
        }
        navigate(`/artist/${artistId}`);
    };

    const handelDialogClose = () => {
        setIsShow(false);
    };

    const { data, isLoading } = useSWR<RandomCertifiedArtistVideo>(
        `/artists/random-video`,
        swrFetcher,
        {
            onSuccess: () => {
                setAlreadyShowedRecommendedArtistDialog();
            },
        }
    );

    if (!data || isLoading || isShow === false) {
        return null;
    }

    return (
        <>
            <div
                className={styles.backdrop}
                onClick={handelDialogClose}
                onKeyDown={handelDialogClose}
                role="button"
                tabIndex={0}
                aria-label="ダイアログを閉じる"
            />
            <div className={styles.container_outer}>
                <div className={styles.container}>
                    <div className={styles.video_container}>
                        <video
                            className={styles.video}
                            controls
                            autoPlay
                            loop
                            muted
                            src={data.video_path.startsWith("http") ? data.video_path : `${S3_URL}/ProfileVideos/${data.id}/${data.video_path}`}
                        />
                    </div>
                    <div className={styles.bottom_area}>
                        <p className={styles.subText}>
                            KOBEまちなかパフォーマンス
                            <br />
                            公認アーティスト
                        </p>
                        {/* ユーザー */}
                        <div
                            className={styles.information_with_icon_container}
                            onClick={() => {
                                navigateArtistProfile(data.id);
                            }}
                            onKeyDown={() => {
                                navigateArtistProfile(data.id);
                            }}
                            role="button"
                            tabIndex={0}
                        >
                            <img
                                className={styles.user_icon}
                                src={getUserIconUrl(data.icon, data.id)}
                                alt=""
                                decoding="async"
                                onError={(e) => {
                                    return imageLoadErrorHandler(e, "icon");
                                }}
                            />
                            <div className={styles.information_text_container}>
                                <h2 className={styles.information_main_text}>
                                    {data.name}
                                </h2>
                                <h3 className={styles.information_sub_text}>
                                    @{data.username}
                                </h3>
                            </div>
                        </div>
                        <Button
                            label="プロフィールを見る"
                            onClick={() => {
                                navigateArtistProfile(data.id);
                            }}
                            type="button"
                            colors="primary"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecommendedArtistDialog;
